/* eslint-disable react/require-default-props */
import React, { useCallback } from 'react'
import { Pager } from '@cb/apricot-react'
import { TableNameOptions } from '@landscape/ui-redux'

// import { useTableContext } from './TableContext' // todo: add change rows per page option
import { getNumberOfPages } from './utils'

interface PaginationProps {
  rowsPerPage: number
  rowCount: number
  onChangePage: Function
  // onChangeRowsPerPage: Function
  currentPage: number
  reduxTableName?: TableNameOptions
}

// todo: add change rows per page option
// const paginationComponentOptions = {
//   rowsPerPageText: 'Rows per page:',
//   rangeSeparatorText: 'of',
//   noRowsPerPage: false,
// }

export const Pagination: React.FC<PaginationProps> = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  // onChangeRowsPerPage, //todo: add change rows per page option
  currentPage,
  reduxTableName,
}) => {
  // todo: add change rows per page option
  // const { paginationRowsPerPageOptions } = useTableContext()
  const numPages = getNumberOfPages(rowCount, rowsPerPage)
  const pagerId = `${reduxTableName}-pager`

  // todo: add change rows per page option
  // const handleRowsPerPage = useCallback(({ target }) => onChangeRowsPerPage(Number(target.value), currentPage), [
  //   currentPage,
  //   onChangeRowsPerPage,
  // ])
  const handlePageChange = useCallback((page) => onChangePage(page), [onChangePage])
  return (
    <div style={{ textAlign: 'center' }}>
      <Pager
        pagerId={pagerId}
        current={currentPage}
        max={numPages}
        delta={2}
        onPageChange={handlePageChange}
        disabled={[]}
      />
    </div>
  )
}
